module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1021-5a8cca676b1a65c17f1b31b793e10509.png";